import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { parseTemplate } from '@core/utilities/utilities.constants';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IProject } from '@shared/services/project.service.types';

@Component({
  selector: 'app-field-item',
  templateUrl: './field-item.component.html',
  styleUrls: ['./field-item.component.scss'],
  imports: [TranslateModule, CommonModule]
})
export class FieldItemComponent {

  @Input() field: IApp.IDescFieldItem;
  @Input() source: any;

  constructor(
    private translateSvc: TranslateService,
  ) { }

  parse(field: IApp.IDescFieldItem, project: IProject) {
    const template = parseTemplate(field, project);
    return field.translate ? this.translateSvc.instant(template) : template;
  }

}
